<div class="p-4">
  <!--<label for="worksurfaceSelect" class="block mb-2 font-medium">Select Worksurface Color</label>-->
  <!--<select
    id="worksurfaceSelect"
    class="border border-stone-400 rounded p-2 w-full mb-3 bg-stone-200 text-black"
    [value]="worksurfaceService.selectedWorksurface()"
    (change)="onWorksurfaceChange($event)"
  >
    @for (w of worksurfaceService.availableWorksurfaces(); track w) {
      <option
        [value]="w.code"
        [selected]="w.code === worksurfaceService.selectedWorksurface().code"
      >
        {{ w.name }}
      </option>
    }
  </select>-->

  <div
    class="flex flex-wrap gap-3 justify-start"
  >
    @for (w of worksurfaceService.availableWorksurfaces(); track w) {
      <div
        class="color-swatch flex flex-col items-center border rounded-md p-2 cursor-pointer transition-all w-24"
        [class.selected]="w.code === worksurfaceService.selectedWorksurface().code"
        (click)="selectWorksurface(w.code)"
      >
        <div class="swatch-box w-16 h-16 mb-1 border rounded flex items-center justify-center">
          <img
            src="images/swatches/{{w.code}}.png"
            alt="{{ w.name }}"
            class="max-w-full max-h-full object-contain"
          />
        </div>

        <div class="text-xs text-center truncate w-full">
          {{ w.name }}
        </div>
      </div>
    }
  </div>
</div>
